import React from 'react'
import styles from './styles.module.css'

function ProductDetails ({ record }) {
  return (
    <section className={styles.containerProductDetails}>
      <div className={styles.containerProductDetailsBoxes}>
        <div className={styles.productDetailsBox}>
          <span>Dimensions</span>
          <p>{record?.dimension ? record.dimension : 'N/A'}</p>
        </div>

        <div className={styles.productDetailsBox}>
          <span>Weight</span>
          <p>{record?.weight ? record.weight : 'N/A'}</p>
        </div>

        <div className={styles.productDetailsBox}>
          <span>Count</span>
          <p>{record?.count ? record.count : 'N/A'}</p>
        </div>
      </div>
    </section>
  )
}

export default ProductDetails
